import { useMemo } from 'react';
import './style.scss';
import { Button, Box, Typography } from '@mui/material';
import { Delete } from '@mui/icons-material';
import StringHelper from '../../helpers/StringHelper';

interface IChipProps {
    label: string;
    size?: 'small' | 'medium' | 'large';
    hoverAction?: 'remove';
    className?: string;
    onClick?: () => void;
}

const Chip: React.FC<IChipProps> = ({
    label,
    size = 'medium',
    hoverAction = undefined,
    className = '',
    onClick = () => {}
}) => {
    label = label.toLowerCase();
    label = StringHelper.FirstLetterUpperCase(label);

    const hoverActionBackdrop = useMemo(() => {
        const chipAttr = {
            className: '',
            Icon: <></>
        };

        if (hoverAction === 'remove') {
            chipAttr.className = `color-red`;
            chipAttr.Icon = <Delete className='chip-backdrop-icon' />;
        }

        return <Button className={`chip-backdrop ${chipAttr.className}`} onClick={onClick}>
            {chipAttr.Icon}
        </Button>;
    }, [hoverAction, onClick]);


    return <Box
        className={`chip-default ${className}`}
        onClick={hoverAction === 'remove' ? undefined : onClick}
    >
        <Typography className={`chip-default-text ${size}`}>
            {label}
        </Typography>

        {
            hoverAction !== undefined && hoverActionBackdrop
        }
    </Box>;
}

export default Chip;